(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advent-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arm(root) {
      if (!root || root.dataset.deAdventArmed) return;
      root.dataset.deAdventArmed = 'true';
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      io.observe(root);
    }
    function init(scope) {
      (scope || document).querySelectorAll('[data-de-advent]').forEach(arm);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ampoule-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arm(root) {
      if (!root || root.dataset.ampstepsArmed) return;
      root.dataset.ampstepsArmed = 'true';
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.3 });
      io.observe(root);
    }
    function init(scope) { (scope || document).querySelectorAll('[data-ampsteps]').forEach(arm); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
